import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Modal, Select, message, notification} from 'antd'
import {updateOriginalFile} from '../../../../../services/api/originalFilesManagementServices'
import {COLORSPACE_OPTIONS, PRINTER_OPTIONS} from '../../../helper/labelFilters'

const {Option} = Select

class EditFileAction extends Component {
    state = {
        visible: false,
        colorspace: this.props.colorspace || '',
        printer: this.props.printer || '',
        loading: false,
    }

    _showModal = () => {
        this.setState({
            visible: true,
            colorspace: this.props.colorspace || '',
            printer: this.props.printer || '',
        })
    }

    _hideModal = () => {
        this.setState({
            visible: false,
            loading: false,
        })
    }

    _handleColorspaceChange = (value) => {
        this.setState({colorspace: value})
    }

    _handlePrinterChange = (value) => {
        this.setState({printer: value})
    }

    _handleSave = async () => {
        const {fileId, onFetchFiles} = this.props
        const {colorspace, printer} = this.state

        this.setState({loading: true})

        try {
            const response = await updateOriginalFile(fileId, {colorspace, printer})

            const {success} = response
            if (!success) {
                throw new Error(response.message || 'Cập nhật thất bại')
            }

            message.success('Cập nhật thành công')
            this._hideModal()

            if (typeof onFetchFiles === 'function') {
                onFetchFiles()
            }
        } catch (e) {
            this.setState({loading: false})
            notification.error({
                message: 'ERROR',
                description: e.message,
                duration: 0,
            })
        }
    }

    render() {
        const {visible, colorspace, printer, loading} = this.state
        const {barcode} = this.props
        const colorspaceOptions = COLORSPACE_OPTIONS.filter(opt => opt.value !== '')
        const printerOptions = PRINTER_OPTIONS.filter(opt => opt.value !== '')

        return (
            <>
                <Button type='link' onClick={this._showModal}>Edit</Button>
                <Modal
                    title={`Chỉnh sửa barcode item ${barcode}`}
                    visible={visible}
                    onCancel={this._hideModal}
                    onOk={this._handleSave}
                    confirmLoading={loading}
                    okText='Lưu'
                    cancelText='Hủy'
                >
                    <div className='mb-3'>
                        <label className='font-weight-bold mb-1 d-block'>Hệ màu file in</label>
                        <Select
                            value={colorspace}
                            onChange={this._handleColorspaceChange}
                            style={{width: '100%'}}
                        >
                            {colorspaceOptions.map(opt => (
                                <Option key={opt.value} value={opt.value}>{opt.name}</Option>
                            ))}
                        </Select>
                    </div>
                    <div className='mb-3'>
                        <label className='font-weight-bold mb-1 d-block'>Loại máy in</label>
                        <Select
                            value={printer}
                            onChange={this._handlePrinterChange}
                            style={{width: '100%'}}
                        >
                            {printerOptions.map(opt => (
                                <Option key={opt.value} value={opt.value}>{opt.name}</Option>
                            ))}
                        </Select>
                    </div>
                </Modal>
            </>
        )
    }
}

EditFileAction.propTypes = {
    fileId: PropTypes.string.isRequired,
    colorspace: PropTypes.string,
    printer: PropTypes.string,
    onFetchFiles: PropTypes.func.isRequired,
}

export default EditFileAction
